import * as Yup from 'yup';

export const validateTaikaikubunCd = Yup.string()
  .nullable()
  .checkValidateNumber('退会区分', 10, true);

export const validateKyufuKingaku = Yup.string()
  .nullable()
  .checkCurrency('退会餞別金', 9, true);
